import gql from 'graphql-tag';
import { uploadPdf } from './uploadPdf';
import { uploadVideo } from './uploadVideo';
import { uploadImage } from './uploadImage';

export const createEvidenceMutation = gql`
  mutation createEvidence(
    $name: String!
    $type: EvidenceType!
    $status: Status!
    $plotId: ID!
    $content: String
    $pdf: String
    $fileName: String
    $uploadChoice: UploadChoice!
    $videoEvidenceLoop: Int
  ) {
    data: createEvidence(
      name: $name
      type: $type
      status: $status
      plotId: $plotId
      content: $content
      pdf: $pdf
      fileName: $fileName
      uploadChoice: $uploadChoice
      videoEvidenceLoop: $videoEvidenceLoop
    ) {
      id
      name
      type
      status
      content
      uploadChoice
      videoEvidenceLoop
      pdf{
        url
        fileName
      }
      plotId {
        id
        name
        status
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const createEvidence = async ({ client, params }) => {
  params.data.plotId = params.data.plot;
  if(params.data.uploadChoice === 'PDF'){
    const response = await uploadPdf(client, params);  
    params.data.pdf = response.accessUrl;
    params.data.fileName = response.fileName;
  } else if (params.data.uploadChoice === 'VIDEO') {
    const response = await uploadVideo(client, params);
    params.data.pdf = response.accessUrl;
    params.data.fileName = response.fileName;
  } else if (params.data.uploadChoice === 'IMAGE') {
    const response = await uploadImage(client, params);
    params.data.pdf = response.accessUrl;
    params.data.fileName = response.fileName;
    delete params.data.image;
  }
  const result = await client.mutate({
    mutation: createEvidenceMutation,
    variables: {
      ...params.data,
    },
  });

  return result.data;
};
